
// import React, { useEffect, useState } from "react";
// import {
//   Accordion,
//   AccordionSummary,
//   AccordionDetails,
//   Typography,
//   Box,
//   Chip,
//   TableContainer,
//   Table,
//   TableHead,
//   TableRow,
//   TableCell,
//   TableBody,
//   Stack,
//   Divider,
//   Tooltip,
//   IconButton,
//   TextField,
// } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Grid from "@mui/material/Grid2";
// import InfoOutlined from "@mui/icons-material/InfoOutlined";
// import InfoIcon from "@mui/icons-material/Info";
// import { palette, theme as colorTheme } from "../../../../Convoze.theme";
// import EditIcon from "@mui/icons-material/Edit";
// import { Calculate } from "@mui/icons-material";
// import CheckIcon from "@mui/icons-material/Check";
// import { jwtDecode } from "jwt-decode";
// const positive = colorTheme("palette", "positive").value;
// const positiveBg = colorTheme("palette", "positiveBg").value;
// const negative = colorTheme("palette", "negative").value;
// const negativeBg = colorTheme("palette", "negativeBg").value;
// const neutral = colorTheme("palette", "neutral").value;
// const neutralBg = colorTheme("palette", "neutralBg").value;
// const primary = colorTheme("palette", "primary").value;

// const getStatusInfo = (value) => {
//   const normalized =
//     typeof value === "string" ? value.trim().toLowerCase() : value;

//   if (
//     normalized === true ||
//     normalized === "true" ||
//     normalized === "pass" ||
//     normalized === "passed" ||
//     normalized === "yes"
//   ) {
//     return { label: "Pass", isPass: true };
//   }

//   if (
//     normalized === false ||
//     normalized === "false" ||
//     normalized === "fail" ||
//     normalized === "failed" ||
//     normalized === "no"
//   ) {
//     return { label: "Fail", isPass: false };
//   }

//   return { label: "N/A", isPass: null };
// };

// const DrillDownAccordion = ({ data, Id }) => {
//   console.log("data", data);
//   const COMPANIES_WITH_SCORING = ["mPokket", "1Finance", "Auric", "Nippon", "VTrans", "Roposo", "vxpressnmc", "EBMS Business (India)", "Expert Plus", "Positive Zone", "EBMS Business – RAKEZ Free Zone"];
//   const token = localStorage.getItem("token");
//   const decodedToken = token ? jwtDecode(token) : {};
//   const showScoringFeatures = COMPANIES_WITH_SCORING.includes(
//     decodedToken?.companyName
//   );
//   // const showScoringFeatures = decodedToken?.companyName === "mPokket";

//   const [statusSummary, setStatusSummary] = useState({
//     mostCritical: false,
//     critical: false,
//     nonCritical: false,
//   });
//   const [edit, setEdit] = useState(true); // start in edit mode
//   const [value, setValue] = useState("");
//   const [auditValues, setAuditValues] = useState({});

//   useEffect(() => {
//     const sections = data && Object.values(data);
//     const checkPass = (criticalityType) => {
//       const filtered = sections?.filter(
//         (s) => s.criticality === criticalityType
//       );

//       if (!filtered || filtered.length === 0) return false;

//       return !filtered.some((section) => {
//         const status = getStatusInfo(
//           section?.result ?? section?.overAllIssueFlagged
//         );
//         return status.isPass === false;
//       });
//     };

//     const mostCriticalPass = checkPass("MostCritical");
//     const criticalPass = checkPass("Critical");
//     const nonCriticalPass = checkPass("NonCritical");

//     setStatusSummary({
//       mostCritical: mostCriticalPass,
//       critical: criticalPass,
//       nonCritical: nonCriticalPass,
//     });
//   }, [data]);

//   const hasMostCritical =
//     data && Object.values(data).some((s) => s?.criticality === "MostCritical");
//   const hasCritical =
//     data && Object.values(data).some((s) => s?.criticality === "Critical");
//   const hasNonCritical =
//     data && Object.values(data).some((s) => s?.criticality === "NonCritical");

//   const noSectionsAvailable =
//     !hasMostCritical && !hasCritical && !hasNonCritical;

//   return (
//     <Box sx={{ width: "100%" }}>
//       {noSectionsAvailable ? (
//         <Box sx={{ textAlign: "center", py: 10 }}>
//           <Typography variant="h6" color="textSecondary">
//             No data available
//           </Typography>
//         </Box>
//       ) : (
//         <Grid container spacing={1}>
//           {/* //mostCritical */}
//           {data &&
//             Object.values(data).some(
//               (section) => section?.criticality === "MostCritical"
//             ) && (
//               <Grid
//                 item
//                 size={{
//                   xs: 12,
//                   md: 12,
//                 }}
//                 sx={{ borderRadius: 6, border: "1px solid #EEEEEE", p: 3 }}
//               >
//                 <Stack
//                   direction="row"
//                   gap={2}
//                   mb={2}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignContent: "center",
//                   }}
//                 >
//                   <Typography
//                     variant="body1"
//                     fontWeight={600}
//                     gutterBottom
//                     // color="#EF5350"
//                     color={negative}
//                     sx={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                     }}
//                   >
//                     Most Critical
//                     <Tooltip title="Key parameters— Standards must be followed">
//                       <InfoIcon
//                         sx={{ fontSize: 18, color: "grey", cursor: "pointer" }}
//                       />
//                     </Tooltip>
//                   </Typography>

//                   {data && Object.keys(data).length > 0 && (
//                     <Box
//                       p={"5px 36px "}
//                       sx={{
//                         border: statusSummary?.mostCritical
//                           ? `1px solid ${positive}`
//                           : `1px solid ${negative}`,
//                         borderRadius: 2,
//                         color: statusSummary?.mostCritical
//                           ? positive
//                           : negative,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {statusSummary?.mostCritical ? "Pass" : "Fail"}
//                     </Box>
//                   )}
//                 </Stack>

//                 {/* <Divider sx={{ mb: 3, mt: 2 }} /> */}

//                 {data && Object.entries(data).length > 0 ? (
//                   Object.entries(data)
//                     .filter(
//                       ([_, sectionData]) =>
//                         sectionData?.criticality == "MostCritical"
//                     )
//                     .map(([sectionKey, sectionData], i) => {
//                       return (
//                         <>
//                           <Accordion key={i} mt={1} mb={2}>
//                             <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                               <Typography variant="body1" sx={{ flexGrow: 1 }}>
//                                 {sectionKey?.replace(
//                                   /([a-z])([A-Z])/g,
//                                   "$1 $2"
//                                 )}
//                               </Typography>
//                               {showScoringFeatures && (
//                                 <Typography sx={{ marginRight: 5 }}>
//                                   Overall Score:{" "}
//                                   <strong>
//                                     {sectionData?.parameterWeigthageCal}
//                                   </strong>
//                                 </Typography>
//                               )}
//                               {/* <Chip
//                                 label={
//                                   sectionData?.overAllIssueFlagged == true
//                                     ? "Pass"
//                                     : sectionData?.overAllIssueFlagged == false
//                                       ? "Fail"
//                                       : "N/A"
//                                 }
//                                 size="small"
//                                 sx={{
//                                   mr: 3,
//                                   color:
//                                     sectionData?.overAllIssueFlagged === true
//                                       ? positive
//                                       : sectionData?.overAllIssueFlagged ===
//                                         false
//                                         ? negative
//                                         : "grey",
//                                   border: "1px solid",
//                                   borderColor:
//                                     sectionData?.overAllIssueFlagged === true
//                                       ? positive
//                                       : sectionData?.overAllIssueFlagged ===
//                                         false
//                                         ? negative
//                                         : "grey",
//                                   background: "transparent",
//                                 }}
//                               /> */}
//                               <Chip
//                                 label={
//                                   getStatusInfo(
//                                     sectionData?.result ??
//                                       sectionData?.overAllIssueFlagged
//                                   ).label
//                                 }
//                                 size="small"
//                                 sx={{
//                                   mr: 3,
//                                   color:
//                                     getStatusInfo(
//                                       sectionData?.result ??
//                                         sectionData?.overAllIssueFlagged
//                                     ).isPass === true
//                                       ? positive
//                                       : getStatusInfo(
//                                           sectionData?.result ??
//                                             sectionData?.overAllIssueFlagged
//                                         ).isPass === false
//                                         ? negative
//                                         : "grey",
//                                   border: "1px solid",
//                                   borderColor:
//                                     getStatusInfo(
//                                       sectionData?.result ??
//                                         sectionData?.overAllIssueFlagged
//                                     ).isPass === true
//                                       ? positive
//                                       : getStatusInfo(
//                                           sectionData?.result ??
//                                             sectionData?.overAllIssueFlagged
//                                         ).isPass === false
//                                         ? negative
//                                         : "grey",
//                                   background: "transparent",
//                                   fontWeight: "bold",
//                                 }}
//                               />
//                             </AccordionSummary>

//                             <AccordionDetails>
//                               <TableContainer>
//                                 <Table size="small">
//                                   <TableHead>
//                                     <TableRow>
//                                       <TableCell>
//                                         <strong>Sub Parameter</strong>
//                                       </TableCell>
//                                       <TableCell>
//                                         <strong>Expectation</strong>
//                                       </TableCell>

//                                       <TableCell>
//                                         <strong>Status</strong>
//                                       </TableCell>
//                                       {/* <TableCell>
//                                         <strong>Timestamp</strong>
//                                       </TableCell> */}
//                                       <TableCell>
//                                         <strong>Reason</strong>
//                                       </TableCell>
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <strong>AI Score</strong>
//                                         </TableCell>
//                                       )}
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <strong>Rating</strong>
//                                         </TableCell>
//                                       )}
//                                     </TableRow>
//                                   </TableHead>
//                                   <TableBody>
//                                     {sectionData?.subParameters?.map(
//                                       (param, idx) => (
//                                         <TableRow key={idx}>
//                                           <TableCell>
//                                             <Tooltip title={param?.description}>
//                                               <IconButton
//                                                 size="small"
//                                                 sx={{ color: primary }}
//                                               >
//                                                 <InfoOutlined
//                                                   sx={{
//                                                     color: primary,
//                                                     fontSize: 20,
//                                                   }}
//                                                 />
//                                               </IconButton>
//                                             </Tooltip>
//                                             {param?.parameter}
//                                           </TableCell>
//                                           <TableCell>
//                                             {param?.expectation}
//                                           </TableCell>
//                                           {/* <TableCell>
//                                             <Chip
//                                               label={
//                                                 param?.issueFlagged == "true"
//                                                   ? "Pass"
//                                                   : param?.issueFlagged ==
//                                                     "false"
//                                                     ? "Fail"
//                                                     : "N/A"
//                                               }
//                                               size="small"
//                                               sx={{
//                                                 border: "1px solid",
//                                                 borderColor:
//                                                   param?.issueFlagged == "true"
//                                                     ? positive
//                                                     : param?.issueFlagged ==
//                                                       "false"
//                                                       ? negative
//                                                       : colorTheme(
//                                                         "palette",
//                                                         "secondary"
//                                                       ).value,
//                                                 color:
//                                                   param?.issueFlagged == "true"
//                                                     ? positive
//                                                     : param?.issueFlagged ==
//                                                       "false"
//                                                       ? negative
//                                                       : colorTheme(
//                                                         "palette",
//                                                         "secondary"
//                                                       ).value,
//                                                 backgroundColor: "transparent",
//                                               }}
//                                             />
//                                           </TableCell> */}
//                                           <TableCell>
//                                             <Chip
//                                               label={
//                                                 getStatusInfo(
//                                                   param?.result ??
//                                                     param?.issueFlagged
//                                                 ).label
//                                               }
//                                               size="small"
//                                               sx={{
//                                                 border: "1px solid",
//                                                 borderColor:
//                                                   getStatusInfo(
//                                                     param?.result ??
//                                                       param?.issueFlagged
//                                                   ).isPass === true
//                                                     ? positive
//                                                     : getStatusInfo(
//                                                         param?.result ??
//                                                           param?.issueFlagged
//                                                       ).isPass === false
//                                                       ? negative
//                                                       : colorTheme(
//                                                           "palette",
//                                                           "secondary"
//                                                         ).value,
//                                                 color:
//                                                   getStatusInfo(
//                                                     param?.result ??
//                                                       param?.issueFlagged
//                                                   ).isPass === true
//                                                     ? positive
//                                                     : getStatusInfo(
//                                                         param?.result ??
//                                                           param?.issueFlagged
//                                                       ).isPass === false
//                                                       ? negative
//                                                       : colorTheme(
//                                                           "palette",
//                                                           "secondary"
//                                                         ).value,
//                                                 backgroundColor: "transparent",
//                                                 fontWeight: "medium",
//                                               }}
//                                             />
//                                           </TableCell>
//                                           {/* <TableCell>{param?.timeStamp}</TableCell> */}
//                                           <TableCell>{param?.reason}</TableCell>
//                                           {showScoringFeatures && (
//                                             <TableCell>
//                                               <Typography
//                                                 sx={{ fontWeight: 600 }}
//                                               >
//                                                 {param?.calculatedWeigthage}/
//                                                 {param?.originalWeightage}
//                                               </Typography>
//                                             </TableCell>
//                                           )}
//                                           {showScoringFeatures && (
//                                             <TableCell>
//                                               <Typography
//                                                 sx={{ fontWeight: 600 }}
//                                               >
//                                                 {param?.rating}
//                                               </Typography>
//                                             </TableCell>
//                                           )}
//                                           {/* {showScoringFeatures && (
//                                             <TableCell>
//                                               <TextField
//                                                 type="tel"
//                                                 variant="standard"
//                                                 value={auditValues[idx] || ""}
//                                                 onChange={(e) => {
//                                                   const val = e.target.value;
//                                                   if (/^[0-9]*$/.test(val)) {
//                                                     setAuditValues((prev) => ({
//                                                       ...prev,
//                                                       [idx]: val,
//                                                     }));
//                                                   }
//                                                 }}
//                                                 fullWidth
//                                                 sx={{
//                                                   "& .MuiInput-underline:before":
//                                                   {
//                                                     borderBottomColor:
//                                                       "#7635DD", // purple default
//                                                   },
//                                                   "& .MuiInput-underline:hover:before":
//                                                   {
//                                                     borderBottomColor:
//                                                       "#7635DD", // darker purple on hover
//                                                   },
//                                                   "& .MuiInput-underline:after": {
//                                                     borderBottomColor: "#7635DD", // purple when active/focused
//                                                   },
//                                                 }}
//                                                 InputProps={{
//                                                   disableUnderline: false,
//                                                   inputProps: {
//                                                     style: {
//                                                       MozAppearance: "textfield",
//                                                     },
//                                                   },
//                                                 }}
//                                               />
//                                             </TableCell>
//                                           )} */}
//                                         </TableRow>
//                                       )
//                                     )}
//                                   </TableBody>
//                                 </Table>
//                               </TableContainer>
//                             </AccordionDetails>
//                           </Accordion>
//                         </>
//                       );
//                     })
//                 ) : (
//                   <Typography>No data available</Typography>
//                 )}
//               </Grid>
//             )}
//           {/* critcle */}
//           {data &&
//             Object.values(data).some(
//               (section) => section?.criticality === "Critical"
//             ) && (
//               <Grid
//                 item
//                 size={{
//                   xs: 12,
//                   md: 12,
//                 }}
//                 sx={{
//                   borderRadius: 6,
//                   border: "1px solid #EEEEEE",
//                   p: 3,
//                   mt: 3,
//                 }}
//               >
//                 <Stack
//                   direction="row"
//                   gap={2}
//                   mt={4}
//                   mb={2}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignContent: "center",
//                   }}
//                 >
//                   <Typography
//                     variant="body1"
//                     fontWeight={600}
//                     gutterBottom
//                     color={negative}
//                   >
//                     Critical
//                   </Typography>
//                   {data && Object.keys(data).length > 0 && (
//                     <Box
//                       p={"5px 36px "}
//                       sx={{
//                         border: statusSummary?.critical
//                           ? `1px solid ${positive}`
//                           : `1px solid ${negative}`,

//                         borderRadius: 2,

//                         color: statusSummary?.critical ? positive : negative,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {statusSummary?.critical ? "Pass" : "Fail"}
//                     </Box>
//                   )}
//                 </Stack>
//                 {data &&
//                   Object.keys(data).length > 0 &&
//                   Object.entries(data).length > 0 &&
//                   Object.values(data).some(
//                     (section) => section?.criticality === "Critical"
//                   ) ? (
//                   Object.entries(data)
//                     .filter(
//                       ([_, sectionData]) =>
//                         sectionData?.criticality === "Critical"
//                     )
//                     .map(([sectionKey, sectionData], i) => (
//                       <Accordion key={i} mb={2}>
//                         <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                           <Typography variant="body1" sx={{ flexGrow: 1 }}>
//                             {sectionKey?.replace(/([a-z])([A-Z])/g, "$1 $2")}
//                           </Typography>
//                           {showScoringFeatures && (
//                             <Typography sx={{ marginRight: 5 }}>
//                               Overall Score:{" "}
//                               <strong>
//                                 {sectionData?.parameterWeigthageCal}
//                               </strong>
//                             </Typography>
//                           )}
//                           <Chip
//                             label={
//                               sectionData?.overAllIssueFlagged == true
//                                 ? "Pass"
//                                 : sectionData?.overAllIssueFlagged == false
//                                   ? "Fail"
//                                   : "N/A"
//                             }
//                             size="small"
//                             sx={{
//                               mr: 3,
//                               color:
//                                 sectionData?.overAllIssueFlagged === true
//                                   ? positive
//                                   : sectionData?.overAllIssueFlagged === false
//                                     ? negative
//                                     : "grey",
//                               border: "1px solid",
//                               borderColor:
//                                 sectionData?.overAllIssueFlagged === true
//                                   ? positive
//                                   : sectionData?.overAllIssueFlagged === false
//                                     ? negative
//                                     : "grey",
//                               background: "transparent",
//                             }}
//                           />
//                         </AccordionSummary>

//                         <AccordionDetails>
//                           <TableContainer>
//                             <Table size="small">
//                               <TableHead>
//                                 <TableRow>
//                                   <TableCell>
//                                     <strong>Sub Parameter</strong>
//                                   </TableCell>
//                                   <TableCell>
//                                     <strong>Expectation</strong>
//                                   </TableCell>
//                                   <TableCell>
//                                     <strong>Status</strong>
//                                   </TableCell>
//                                   {/* <TableCell>
//                                     <strong>Timestamp</strong>
//                                   </TableCell> */}
//                                   <TableCell>
//                                     <strong>Reason</strong>
//                                   </TableCell>
//                                   {showScoringFeatures && (
//                                     <TableCell>
//                                       <strong>AI Score</strong>
//                                     </TableCell>
//                                   )}
//                                   {showScoringFeatures && (
//                                     <TableCell>
//                                       <strong>Rating</strong>
//                                     </TableCell>
//                                   )}
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {sectionData?.subParameters?.map(
//                                   (param, idx) => (
//                                     <TableRow key={idx}>
//                                       <TableCell>
//                                         {" "}
//                                         <Tooltip title={param?.description}>
//                                           <IconButton
//                                             size="small"
//                                             sx={{ color: primary }}
//                                           >
//                                             <InfoOutlined
//                                               sx={{
//                                                 color: primary,
//                                                 fontSize: 20,
//                                               }}
//                                             />
//                                           </IconButton>
//                                         </Tooltip>
//                                         {param?.parameter}
//                                       </TableCell>
//                                       <TableCell>
//                                         {param?.expectation}
//                                       </TableCell>
//                                       {/* <TableCell>
//                                         <Chip
//                                           label={
//                                             param?.issueFlagged == "true"
//                                               ? positive
//                                               : param?.issueFlagged == "false"
//                                                 ? negative
//                                                 : "N/A"
//                                           }
//                                           size="small"
//                                           sx={{
//                                             border: "1px solid",

//                                             border: "1px solid",
//                                             borderColor:
//                                               param?.issueFlagged == "true"
//                                                 ? positive
//                                                 : param?.issueFlagged == "false"
//                                                   ? negative
//                                                   : colorTheme(
//                                                     "palette",
//                                                     "secondary"
//                                                   ).value,

//                                             color:
//                                               param?.issueFlagged == "true"
//                                                 ? positive
//                                                 : param?.issueFlagged == "false"
//                                                   ? negative
//                                                   : colorTheme(
//                                                     "palette",
//                                                     "secondary"
//                                                   ).value,
//                                             backgroundColor: "transparent",
//                                           }}
//                                         />
//                                       </TableCell> */}
//                                       <TableCell>
//                                         <Chip
//                                           label={
//                                             String(param?.issueFlagged) === "true"
//                                               ? "Pass"
//                                               : String(param?.issueFlagged) === "false"
//                                                 ? "Fail"
//                                                 : "N/A"
//                                           }
//                                           size="small"
//                                           sx={{
//                                             border: "1px solid",
//                                             borderColor:
//                                               String(param?.issueFlagged) === "true"
//                                                 ? positive
//                                                 : String(param?.issueFlagged) === "false"
//                                                   ? negative
//                                                   : colorTheme("palette", "secondary").value,
//                                             color:
//                                               String(param?.issueFlagged) === "true"
//                                                 ? positive
//                                                 : String(param?.issueFlagged) === "false"
//                                                   ? negative
//                                                   : colorTheme("palette", "secondary").value,
//                                             backgroundColor: "transparent",
//                                             fontWeight: "medium",
//                                           }}
//                                         />
//                                       </TableCell>
//                                       {/* <TableCell>{param?.timeStamp}</TableCell> */}
//                                       <TableCell>{param?.reason}</TableCell>
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <Typography sx={{ fontWeight: 600 }}>
//                                             {param?.calculatedWeigthage}/
//                                             {param?.originalWeightage}
//                                           </Typography>
//                                         </TableCell>
//                                       )}
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <Typography sx={{ fontWeight: 600 }}>
//                                             {param?.rating}
//                                           </Typography>
//                                         </TableCell>
//                                       )}

//                                       {/* {showScoringFeatures && (
//                                         <TableCell>
//                                           <TextField
//                                             type="tel"
//                                             variant="standard"
//                                             value={auditValues[idx] || ""}
//                                             onChange={(e) => {
//                                               const val = e.target.value;
//                                               if (/^[0-9]*$/.test(val)) {
//                                                 setAuditValues((prev) => ({
//                                                   ...prev,
//                                                   [idx]: val,
//                                                 }));
//                                               }
//                                             }}
//                                             fullWidth
//                                             sx={{
//                                               "& .MuiInput-underline:before": {
//                                                 borderBottomColor: "#7635DD", // purple default
//                                               },
//                                               "& .MuiInput-underline:hover:before":
//                                               {
//                                                 borderBottomColor: "#7635DD", // darker purple on hover
//                                               },
//                                               "& .MuiInput-underline:after": {
//                                                 borderBottomColor: "#7635DD", // purple when active/focused
//                                               },
//                                             }}
//                                             InputProps={{
//                                               disableUnderline: false,
//                                               // endAdornment: (
//                                               //   <span style={{ marginLeft: 8, color: "#666", fontSize: 14 }}>
//                                               //     / {param?.originalWeightage}
//                                               //   </span>
//                                               // ),
//                                               inputProps: {
//                                                 style: { MozAppearance: "textfield" },
//                                               },
//                                             }}
//                                           />
//                                         </TableCell>
//                                       )} */}
//                                     </TableRow>
//                                   )
//                                 )}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                         </AccordionDetails>
//                       </Accordion>
//                     ))
//                 ) : (
//                   <Typography>No Critical data available</Typography>
//                 )}
//               </Grid>
//             )}
//           {/* nonCritical */}
//           {data &&
//             Object.values(data).some(
//               (section) => section?.criticality === "NonCritical"
//             ) && (
//               <Grid
//                 item
//                 size={{
//                   xs: 12,
//                   md: 12,
//                 }}
//                 sx={{
//                   borderRadius: 6,
//                   border: "1px solid #EEEEEE",
//                   p: 3,
//                   mt: 3,
//                 }}
//               >
//                 <Stack
//                   direction="row"
//                   gap={2}
//                   mt={4}
//                   mb={2}
//                   sx={{
//                     display: "flex",
//                     justifyContent: "space-between",
//                     alignContent: "center",
//                   }}
//                 >
//                   <Typography
//                     variant="body1"
//                     fontWeight={600}
//                     gutterBottom
//                     color={positive}
//                     sx={{
//                       display: "inline-flex",
//                       alignItems: "center",
//                       gap: 0.5,
//                     }}
//                   >
//                     Non Critical
//                     <Tooltip title="Supporting parameters – Standards are important/encouraged to meet">
//                       <InfoIcon
//                         sx={{ fontSize: 18, color: "grey", cursor: "pointer" }}
//                       />
//                     </Tooltip>
//                   </Typography>

//                   {data && Object.keys(data).length > 0 && (
//                     <Box
//                       p={"5px 36px "}
//                       sx={{
//                         border: statusSummary?.nonCritical
//                           ? `1px solid ${positive}`
//                           : `1px solid ${negative}`,
//                         borderRadius: 2,
//                         color: statusSummary?.nonCritical ? positive : negative,
//                         fontWeight: "bold",
//                       }}
//                     >
//                       {statusSummary?.nonCritical ? "Pass" : "Fail"}
//                     </Box>
//                   )}
//                 </Stack>
//                 {/* <Divider sx={{ mb: 3, mt: 2 }} /> */}
//                 {data && Object.entries(data).length > 0 ? (
//                   Object.entries(data)
//                     .filter(
//                       ([_, sectionData]) =>
//                         sectionData?.criticality == "NonCritical"
//                     )
//                     .map(([sectionKey, sectionData], i) => (
//                       <Accordion key={i}>
//                         <AccordionSummary expandIcon={<ExpandMoreIcon />}>
//                           <Typography variant="body1" sx={{ flexGrow: 1 }}>
//                             {sectionKey?.replace(/([a-z])([A-Z])/g, "$1 $2")}
//                           </Typography>
//                           {showScoringFeatures && (
//                             <Typography sx={{ marginRight: 5 }}>
//                               Overall Score:{" "}
//                               <strong>
//                                 {sectionData?.parameterWeigthageCal}
//                               </strong>
//                             </Typography>
//                           )}
//                           <Chip
//                             label={
//                               sectionData?.overAllIssueFlagged == true
//                                 ? "Pass"
//                                 : sectionData?.overAllIssueFlagged == false
//                                   ? "Fail"
//                                   : "N/A"
//                             }
//                             size="small"
//                             sx={{
//                               mr: 3,
//                               color:
//                                 sectionData?.overAllIssueFlagged === true
//                                   ? positive
//                                   : sectionData?.overAllIssueFlagged === false
//                                     ? negative
//                                     : "grey",
//                               border: "1px solid",
//                               borderColor:
//                                 sectionData?.overAllIssueFlagged === true
//                                   ? positive
//                                   : sectionData?.overAllIssueFlagged === false
//                                     ? negative
//                                     : "grey",
//                               background: "transparent",
//                             }}
//                           />
//                         </AccordionSummary>

//                         <AccordionDetails>
//                           <TableContainer>
//                             <Table size="small">
//                               <TableHead>
//                                 <TableRow>
//                                   <TableCell>
//                                     <strong>Sub Parameter</strong>
//                                   </TableCell>
//                                   <TableCell>
//                                     <strong>Expectation</strong>
//                                   </TableCell>

//                                   <TableCell>
//                                     <strong>Status</strong>
//                                   </TableCell>
//                                   {/* <TableCell>
//                                     <strong>Timestamp</strong>
//                                   </TableCell> */}
//                                   <TableCell>
//                                     <strong>Reason</strong>
//                                   </TableCell>
//                                   {showScoringFeatures && (
//                                     <TableCell>
//                                       <strong>AI Score</strong>
//                                     </TableCell>)}
//                                   {showScoringFeatures && (
//                                     <TableCell>
//                                       <strong>Rating</strong>
//                                     </TableCell>)}
//                                 </TableRow>
//                               </TableHead>
//                               <TableBody>
//                                 {sectionData?.subParameters?.map(
//                                   (param, idx) => (
//                                     <TableRow key={idx}>
//                                       <TableCell>
//                                         {" "}
//                                         <Tooltip title={param?.description}>
//                                           <IconButton
//                                             size="small"
//                                             sx={{ color: primary }}
//                                           >
//                                             <InfoOutlined
//                                               sx={{
//                                                 color: primary,
//                                                 fontSize: 20,
//                                               }}
//                                             />
//                                           </IconButton>
//                                         </Tooltip>
//                                         {param?.parameter}
//                                       </TableCell>
//                                       <TableCell>
//                                         {param?.expectation}
//                                       </TableCell>
//                                       {/* <TableCell>
//                                         <Chip
//                                           label={
//                                             param?.issueFlagged == "true"
//                                               ? "Pass"
//                                               : param?.issueFlagged == "false"
//                                                 ? "Fail"
//                                                 : "N/A"
//                                           }
//                                           size="small"
//                                           sx={{
//                                             border: "1px solid",
//                                             borderColor:
//                                               param?.issueFlagged == "true"
//                                                 ? positive
//                                                 : param?.issueFlagged == "false"
//                                                   ? negative
//                                                   : colorTheme(
//                                                     "palette",
//                                                     "secondary"
//                                                   ).value,
//                                             color:
//                                               param?.issueFlagged == "true"
//                                                 ? positive
//                                                 : param?.issueFlagged == "false"
//                                                   ? negative
//                                                   : "grey",
//                                             backgroundColor: "transparent",
//                                           }}
//                                         />
//                                       </TableCell> */}
//                                       <TableCell>
//                                         <Chip
//                                           label={
//                                             String(param?.issueFlagged) === "true"
//                                               ? "Pass"
//                                               : String(param?.issueFlagged) === "false"
//                                                 ? "Fail"
//                                                 : "N/A"
//                                           }
//                                           size="small"
//                                           sx={{
//                                             border: "1px solid",
//                                             borderColor:
//                                               String(param?.issueFlagged) === "true"
//                                                 ? positive
//                                                 : String(param?.issueFlagged) === "false"
//                                                   ? negative
//                                                   : colorTheme("palette", "secondary").value,
//                                             color:
//                                               String(param?.issueFlagged) === "true"
//                                                 ? positive
//                                                 : String(param?.issueFlagged) === "false"
//                                                   ? negative
//                                                   : colorTheme("palette", "secondary").value,
//                                             backgroundColor: "transparent",
//                                             fontWeight: "medium",
//                                           }}
//                                         />
//                                       </TableCell>
//                                       {/* <TableCell>{param?.timeStamp}</TableCell> */}
//                                       <TableCell>{param?.reason}</TableCell>
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <Typography sx={{ fontWeight: 600 }}>
//                                             {param?.calculatedWeigthage}/
//                                             {param?.originalWeightage}
//                                           </Typography>
//                                         </TableCell>
//                                       )}
//                                       {showScoringFeatures && (
//                                         <TableCell>
//                                           <Typography sx={{ fontWeight: 600 }}>
//                                             {param?.rating}
//                                           </Typography>
//                                         </TableCell>
//                                       )}
//                                       {/* {showScoringFeatures && (
//                                         <TableCell>
//                                           <TextField
//                                             type="tel"
//                                             variant="standard"
//                                             value={auditValues[idx] || ""}
//                                             onChange={(e) => {
//                                               const val = e.target.value;
//                                               if (/^[0-9]*$/.test(val)) {
//                                                 setAuditValues((prev) => ({
//                                                   ...prev,
//                                                   [idx]: val,
//                                                 }));
//                                               }
//                                             }}
//                                             fullWidth
//                                             sx={{
//                                               "& .MuiInput-underline:before": {
//                                                 borderBottomColor: "#7635DD", // purple default
//                                               },
//                                               "& .MuiInput-underline:hover:before":
//                                               {
//                                                 borderBottomColor: "#7635DD", // darker purple on hover
//                                               },
//                                               "& .MuiInput-underline:after": {
//                                                 borderBottomColor: "#7635DD", // purple when active/focused
//                                               },
//                                             }}
//                                             InputProps={{
//                                               disableUnderline: false,
//                                               endAdornment: (
//                                                 <span style={{}}>
//                                                   / {param?.originalWeightage}
//                                                 </span>
//                                               ),
//                                               inputProps: {
//                                                 style: { MozAppearance: "textfield" },
//                                               },
//                                             }}
//                                           />
//                                         </TableCell>
//                                       )} */}
//                                     </TableRow>
//                                   )
//                                 )}
//                               </TableBody>
//                             </Table>
//                           </TableContainer>
//                         </AccordionDetails>
//                       </Accordion>
//                     ))
//                 ) : (
//                   <Typography>No data available</Typography>
//                 )}
//               </Grid>
//             )}
//         </Grid>
//       )}
//     </Box>
//   );
// };

// export default DrillDownAccordion;



import React, { useEffect, useState } from "react";
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Box,
  Chip,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Divider,
  Tooltip,
  IconButton,
  TextField,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Grid from "@mui/material/Grid2";
import InfoOutlined from "@mui/icons-material/InfoOutlined";
import InfoIcon from "@mui/icons-material/Info";
import { palette, theme as colorTheme } from "../../../../Convoze.theme";
import EditIcon from "@mui/icons-material/Edit";
import { Calculate } from "@mui/icons-material";
import CheckIcon from "@mui/icons-material/Check";
import { jwtDecode } from "jwt-decode";
const positive = colorTheme("palette", "positive").value;
const positiveBg = colorTheme("palette", "positiveBg").value;
const negative = colorTheme("palette", "negative").value;
const negativeBg = colorTheme("palette", "negativeBg").value;
const neutral = colorTheme("palette", "neutral").value;
const neutralBg = colorTheme("palette", "neutralBg").value;
const primary = colorTheme("palette", "primary").value;

const getStatusInfo = (value) => {
  if (value && typeof value === "object" && Array.isArray(value.subParameters)) {
    const statuses = value.subParameters
      .map((item) => item?.result ?? item?.issueFlagged)
      .map((item) => getStatusInfo(item));
    if (statuses.some((item) => item.isPass === false)) {
      return { label: "Fail", isPass: false };
    }
    if (statuses.some((item) => item.isPass === true)) {
      return { label: "Pass", isPass: true };
    }
    return { label: "N/A", isPass: null };
  }

  const normalized =
    typeof value === "string" ? value.trim().toLowerCase() : value;

  if (
    normalized === true ||
    normalized === "true" ||
    normalized === "pass" ||
    normalized === "passed" ||
    normalized === "yes"
  ) {
    return { label: "Pass", isPass: true };
  }

  if (
    normalized === false ||
    normalized === "false" ||
    normalized === "fail" ||
    normalized === "failed" ||
    normalized === "no"
  ) {
    return { label: "Fail", isPass: false };
  }

  return { label: "N/A", isPass: null };
};

const getSummaryStatus = (value) => getStatusInfo(value);

const DrillDownAccordion = ({ data, Id }) => {
  console.log("data", data);
  const COMPANIES_WITH_SCORING = ["mPokket", "1Finance", "Auric", "Nippon", "VTrans", "Roposo", "vxpressnmc", "EBMS Business (India)", "Expert Plus", "Positive Zone", "EBMS Business – RAKEZ Free Zone"];
  const token = localStorage.getItem("token");
  const decodedToken = token ? jwtDecode(token) : {};
  const showScoringFeatures = COMPANIES_WITH_SCORING.includes(
    decodedToken?.companyName
  );
  // const showScoringFeatures = decodedToken?.companyName === "mPokket";

  const [statusSummary, setStatusSummary] = useState({
    mostCritical: null,
    critical: null,
    nonCritical: null,
  });
  const [edit, setEdit] = useState(true); // start in edit mode
  const [value, setValue] = useState("");
  const [auditValues, setAuditValues] = useState({});

  useEffect(() => {
    const sections = data && Object.values(data);
    const checkPass = (criticalityType) => {
      const filtered = sections?.filter(
        (s) => s.criticality === criticalityType
      );

      if (!filtered || filtered.length === 0) return null;

      const statuses = filtered.map((section) =>
        getStatusInfo(section?.result ?? section?.overAllIssueFlagged ?? section)
      );
      if (statuses.some((status) => status.isPass === false)) return false;
      if (statuses.some((status) => status.isPass === true)) return true;
      return null;
    };

    const mostCriticalPass = checkPass("MostCritical");
    const criticalPass = checkPass("Critical");
    const nonCriticalPass = checkPass("NonCritical");

    setStatusSummary({
      mostCritical: mostCriticalPass,
      critical: criticalPass,
      nonCritical: nonCriticalPass,
    });
  }, [data]);

  const hasMostCritical =
    data && Object.values(data).some((s) => s?.criticality === "MostCritical");
  const hasCritical =
    data && Object.values(data).some((s) => s?.criticality === "Critical");
  const hasNonCritical =
    data && Object.values(data).some((s) => s?.criticality === "NonCritical");

  const noSectionsAvailable =
    !hasMostCritical && !hasCritical && !hasNonCritical;

  return (
    <Box sx={{ width: "100%" }}>
      {noSectionsAvailable ? (
        <Box sx={{ textAlign: "center", py: 10 }}>
          <Typography variant="h6" color="textSecondary">
            No data available
          </Typography>
        </Box>
      ) : (
        <Grid container spacing={1}>
          {/* //mostCritical */}
          {data &&
            Object.values(data).some(
              (section) => section?.criticality === "MostCritical"
            ) && (
              <Grid
                item
                size={{
                  xs: 12,
                  md: 12,
                }}
                sx={{ borderRadius: 6, border: "1px solid #EEEEEE", p: 3 }}
              >
                <Stack
                  direction="row"
                  gap={2}
                  mb={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignContent: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    gutterBottom
                    // color="#EF5350"
                    color={negative}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    Most Critical
                    <Tooltip title="Key parameters— Standards must be followed">
                      <InfoIcon
                        sx={{ fontSize: 18, color: "grey", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </Typography>

                  {data && Object.keys(data).length > 0 && (
                    <Box
                      p={"5px 36px "}
                      sx={{
                        border: `1px solid ${
                          getSummaryStatus(statusSummary?.mostCritical).isPass === true
                            ? positive
                            : getSummaryStatus(statusSummary?.mostCritical).isPass === false
                              ? negative
                              : "#999"
                        }`,
                        borderRadius: 2,
                        color: getSummaryStatus(statusSummary?.mostCritical).isPass === true
                          ? positive
                          : getSummaryStatus(statusSummary?.mostCritical).isPass === false
                            ? negative
                            : "#777",
                        fontWeight: "bold",
                      }}
                    >
                      {getSummaryStatus(statusSummary?.mostCritical).label}
                    </Box>
                  )}
                </Stack>

                {/* <Divider sx={{ mb: 3, mt: 2 }} /> */}

                {data && Object.entries(data).length > 0 ? (
                  Object.entries(data)
                    .filter(
                      ([_, sectionData]) =>
                        sectionData?.criticality == "MostCritical"
                    )
                    .map(([sectionKey, sectionData], i) => {
                      return (
                        <>
                          <Accordion key={i} mt={1} mb={2}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                              <Typography variant="body1" sx={{ flexGrow: 1 }}>
                                {sectionKey?.replace(
                                  /([a-z])([A-Z])/g,
                                  "$1 $2"
                                )}
                              </Typography>
                              {showScoringFeatures && (
                                <Typography sx={{ marginRight: 5 }}>
                                  Overall Score:{" "}
                                  <strong>
                                    {sectionData?.parameterWeigthageCal}
                                  </strong>
                                </Typography>
                              )}
                              {/* <Chip
                                label={
                                  sectionData?.overAllIssueFlagged == true
                                    ? "Pass"
                                    : sectionData?.overAllIssueFlagged == false
                                      ? "Fail"
                                      : "N/A"
                                }
                                size="small"
                                sx={{
                                  mr: 3,
                                  color:
                                    sectionData?.overAllIssueFlagged === true
                                      ? positive
                                      : sectionData?.overAllIssueFlagged ===
                                        false
                                        ? negative
                                        : "grey",
                                  border: "1px solid",
                                  borderColor:
                                    sectionData?.overAllIssueFlagged === true
                                      ? positive
                                      : sectionData?.overAllIssueFlagged ===
                                        false
                                        ? negative
                                        : "grey",
                                  background: "transparent",
                                }}
                              /> */}
                              <Chip
                                label={
                                  getStatusInfo(
                                    sectionData?.result ??
                                      sectionData?.overAllIssueFlagged ?? sectionData
                                  ).label
                                }
                                size="small"
                                sx={{
                                  mr: 3,
                                  color:
                                    getStatusInfo(
                                      sectionData?.result ??
                                      sectionData?.overAllIssueFlagged ?? sectionData
                                    ).isPass === true
                                      ? positive
                                      : getStatusInfo(
                                          sectionData?.result ??
                                            sectionData?.overAllIssueFlagged
                                        ).isPass === false
                                        ? negative
                                        : "grey",
                                  border: "1px solid",
                                  borderColor:
                                    getStatusInfo(
                                      sectionData?.result ??
                                        sectionData?.overAllIssueFlagged ?? sectionData
                                    ).isPass === true
                                      ? positive
                                      : getStatusInfo(
                                          sectionData?.result ??
                                            sectionData?.overAllIssueFlagged
                                        ).isPass === false
                                        ? negative
                                        : "grey",
                                  background: "transparent",
                                  fontWeight: "bold",
                                }}
                              />
                            </AccordionSummary>

                            <AccordionDetails>
                              <TableContainer>
                                <Table size="small">
                                  <TableHead>
                                    <TableRow>
                                      <TableCell>
                                        <strong>Sub Parameter</strong>
                                      </TableCell>
                                      <TableCell>
                                        <strong>Expectation</strong>
                                      </TableCell>

                                      <TableCell>
                                        <strong>Status</strong>
                                      </TableCell>
                                      {/* <TableCell>
                                        <strong>Timestamp</strong>
                                      </TableCell> */}
                                      <TableCell>
                                        <strong>Reason</strong>
                                      </TableCell>
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <strong>AI Score</strong>
                                        </TableCell>
                                      )}
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <strong>Rating</strong>
                                        </TableCell>
                                      )}
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {sectionData?.subParameters?.map(
                                      (param, idx) => (
                                        <TableRow key={idx}>
                                          <TableCell>
                                            <Tooltip title={param?.description}>
                                              <IconButton
                                                size="small"
                                                sx={{ color: primary }}
                                              >
                                                <InfoOutlined
                                                  sx={{
                                                    color: primary,
                                                    fontSize: 20,
                                                  }}
                                                />
                                              </IconButton>
                                            </Tooltip>
                                            {param?.parameter}
                                          </TableCell>
                                          <TableCell>
                                            {param?.expectation}
                                          </TableCell>
                                          {/* <TableCell>
                                            <Chip
                                              label={
                                                param?.issueFlagged == "true"
                                                  ? "Pass"
                                                  : param?.issueFlagged ==
                                                    "false"
                                                    ? "Fail"
                                                    : "N/A"
                                              }
                                              size="small"
                                              sx={{
                                                border: "1px solid",
                                                borderColor:
                                                  param?.issueFlagged == "true"
                                                    ? positive
                                                    : param?.issueFlagged ==
                                                      "false"
                                                      ? negative
                                                      : colorTheme(
                                                        "palette",
                                                        "secondary"
                                                      ).value,
                                                color:
                                                  param?.issueFlagged == "true"
                                                    ? positive
                                                    : param?.issueFlagged ==
                                                      "false"
                                                      ? negative
                                                      : colorTheme(
                                                        "palette",
                                                        "secondary"
                                                      ).value,
                                                backgroundColor: "transparent",
                                              }}
                                            />
                                          </TableCell> */}
                                          <TableCell>
                                            <Chip
                                              label={
                                                getStatusInfo(
                                                  param?.result ??
                                                    param?.issueFlagged
                                                ).label
                                              }
                                              size="small"
                                              sx={{
                                                border: "1px solid",
                                                borderColor:
                                                  getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === true
                                                    ? positive
                                                    : getStatusInfo(
                                                        param?.result ??
                                                          param?.issueFlagged
                                                      ).isPass === false
                                                      ? negative
                                                      : colorTheme(
                                                          "palette",
                                                          "secondary"
                                                        ).value,
                                                color:
                                                  getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === true
                                                    ? positive
                                                    : getStatusInfo(
                                                        param?.result ??
                                                          param?.issueFlagged
                                                      ).isPass === false
                                                      ? negative
                                                      : colorTheme(
                                                          "palette",
                                                          "secondary"
                                                        ).value,
                                                backgroundColor: "transparent",
                                                fontWeight: "medium",
                                              }}
                                            />
                                          </TableCell>
                                          {/* <TableCell>{param?.timeStamp}</TableCell> */}
                                          <TableCell>{param?.reason}</TableCell>
                                          {showScoringFeatures && (
                                            <TableCell>
                                              <Typography
                                                sx={{ fontWeight: 600 }}
                                              >
                                                {param?.calculatedWeigthage}/
                                                {param?.originalWeightage}
                                              </Typography>
                                            </TableCell>
                                          )}
                                          {showScoringFeatures && (
                                            <TableCell>
                                              <Typography
                                                sx={{ fontWeight: 600 }}
                                              >
                                                {param?.rating}
                                              </Typography>
                                            </TableCell>
                                          )}
                                          {/* {showScoringFeatures && (
                                            <TableCell>
                                              <TextField
                                                type="tel"
                                                variant="standard"
                                                value={auditValues[idx] || ""}
                                                onChange={(e) => {
                                                  const val = e.target.value;
                                                  if (/^[0-9]*$/.test(val)) {
                                                    setAuditValues((prev) => ({
                                                      ...prev,
                                                      [idx]: val,
                                                    }));
                                                  }
                                                }}
                                                fullWidth
                                                sx={{
                                                  "& .MuiInput-underline:before":
                                                  {
                                                    borderBottomColor:
                                                      "#7635DD", // purple default
                                                  },
                                                  "& .MuiInput-underline:hover:before":
                                                  {
                                                    borderBottomColor:
                                                      "#7635DD", // darker purple on hover
                                                  },
                                                  "& .MuiInput-underline:after": {
                                                    borderBottomColor: "#7635DD", // purple when active/focused
                                                  },
                                                }}
                                                InputProps={{
                                                  disableUnderline: false,
                                                  inputProps: {
                                                    style: {
                                                      MozAppearance: "textfield",
                                                    },
                                                  },
                                                }}
                                              />
                                            </TableCell>
                                          )} */}
                                        </TableRow>
                                      )
                                    )}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </AccordionDetails>
                          </Accordion>
                        </>
                      );
                    })
                ) : (
                  <Typography>No data available</Typography>
                )}
              </Grid>
            )}
          {/* critcle */}
          {data &&
            Object.values(data).some(
              (section) => section?.criticality === "Critical"
            ) && (
              <Grid
                item
                size={{
                  xs: 12,
                  md: 12,
                }}
                sx={{
                  borderRadius: 6,
                  border: "1px solid #EEEEEE",
                  p: 3,
                  mt: 3,
                }}
              >
                <Stack
                  direction="row"
                  gap={2}
                  mt={4}
                  mb={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignContent: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    gutterBottom
                    color={negative}
                  >
                    Critical
                  </Typography>
                  {data && Object.keys(data).length > 0 && (
                    <Box
                      p={"5px 36px "}
                      sx={{
                        border: `1px solid ${
                          getSummaryStatus(statusSummary?.critical).isPass === true
                            ? positive
                            : getSummaryStatus(statusSummary?.critical).isPass === false
                              ? negative
                              : "#999"
                        }`,

                        borderRadius: 2,

                        color: getSummaryStatus(statusSummary?.critical).isPass === true
                          ? positive
                          : getSummaryStatus(statusSummary?.critical).isPass === false
                            ? negative
                            : "#777",
                        fontWeight: "bold",
                      }}
                    >
                      {getSummaryStatus(statusSummary?.critical).label}
                    </Box>
                  )}
                </Stack>
                {data &&
                  Object.keys(data).length > 0 &&
                  Object.entries(data).length > 0 &&
                  Object.values(data).some(
                    (section) => section?.criticality === "Critical"
                  ) ? (
                  Object.entries(data)
                    .filter(
                      ([_, sectionData]) =>
                        sectionData?.criticality === "Critical"
                    )
                    .map(([sectionKey, sectionData], i) => (
                      <Accordion key={i} mb={2}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="body1" sx={{ flexGrow: 1 }}>
                            {sectionKey?.replace(/([a-z])([A-Z])/g, "$1 $2")}
                          </Typography>
                          {showScoringFeatures && (
                            <Typography sx={{ marginRight: 5 }}>
                              Overall Score:{" "}
                              <strong>
                                {sectionData?.parameterWeigthageCal}
                              </strong>
                            </Typography>
                          )}
                          <Chip
                            label={
                              getStatusInfo(
                                sectionData?.result ??
                                  sectionData?.overAllIssueFlagged ?? sectionData
                              ).label
                            }
                            size="small"
                            sx={{
                              mr: 3,
                              color:
                                getStatusInfo(
                                  sectionData?.result ??
                                    sectionData?.overAllIssueFlagged ?? sectionData
                                ).isPass === true
                                  ? positive
                                  : getStatusInfo(
                                      sectionData?.result ??
                                            sectionData?.overAllIssueFlagged ?? sectionData
                                    ).isPass === false
                                    ? negative
                                    : "grey",
                              border: "1px solid",
                              borderColor:
                                getStatusInfo(
                                  sectionData?.result ??
                                      sectionData?.overAllIssueFlagged ?? sectionData
                                ).isPass === true
                                  ? positive
                                  : getStatusInfo(
                                      sectionData?.result ??
                                        sectionData?.overAllIssueFlagged ?? sectionData
                                    ).isPass === false
                                    ? negative
                                    : "grey",
                              background: "transparent",
                            }}
                          />
                        </AccordionSummary>

                        <AccordionDetails>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>
                                    <strong>Sub Parameter</strong>
                                  </TableCell>
                                  <TableCell>
                                    <strong>Expectation</strong>
                                  </TableCell>
                                  <TableCell>
                                    <strong>Status</strong>
                                  </TableCell>
                                  {/* <TableCell>
                                    <strong>Timestamp</strong>
                                  </TableCell> */}
                                  <TableCell>
                                    <strong>Reason</strong>
                                  </TableCell>
                                  {showScoringFeatures && (
                                    <TableCell>
                                      <strong>AI Score</strong>
                                    </TableCell>
                                  )}
                                  {showScoringFeatures && (
                                    <TableCell>
                                      <strong>Rating</strong>
                                    </TableCell>
                                  )}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {sectionData?.subParameters?.map(
                                  (param, idx) => (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {" "}
                                        <Tooltip title={param?.description}>
                                          <IconButton
                                            size="small"
                                            sx={{ color: primary }}
                                          >
                                            <InfoOutlined
                                              sx={{
                                                color: primary,
                                                fontSize: 20,
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        {param?.parameter}
                                      </TableCell>
                                      <TableCell>
                                        {param?.expectation}
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={
                                            getStatusInfo(
                                              param?.result ??
                                                param?.issueFlagged
                                            ).label
                                          }
                                          size="small"
                                          sx={{
                                            border: "1px solid",
                                            borderColor:
                                              getStatusInfo(
                                                param?.result ??
                                                  param?.issueFlagged
                                              ).isPass === true
                                                ? positive
                                                : getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === false
                                                  ? negative
                                                  : colorTheme(
                                                      "palette",
                                                      "secondary"
                                                    ).value,
                                            color:
                                              getStatusInfo(
                                                param?.result ??
                                                  param?.issueFlagged
                                              ).isPass === true
                                                ? positive
                                                : getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === false
                                                  ? negative
                                                  : colorTheme(
                                                      "palette",
                                                      "secondary"
                                                    ).value,
                                            backgroundColor: "transparent",
                                            fontWeight: "medium",
                                          }}
                                        />
                                      </TableCell>
                                      {/* <TableCell>{param?.timeStamp}</TableCell> */}
                                      <TableCell>{param?.reason}</TableCell>
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <Typography sx={{ fontWeight: 600 }}>
                                            {param?.calculatedWeigthage}/
                                            {param?.originalWeightage}
                                          </Typography>
                                        </TableCell>
                                      )}
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <Typography sx={{ fontWeight: 600 }}>
                                            {param?.rating}
                                          </Typography>
                                        </TableCell>
                                      )}

                                      {/* {showScoringFeatures && (
                                        <TableCell>
                                          <TextField
                                            type="tel"
                                            variant="standard"
                                            value={auditValues[idx] || ""}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (/^[0-9]*$/.test(val)) {
                                                setAuditValues((prev) => ({
                                                  ...prev,
                                                  [idx]: val,
                                                }));
                                              }
                                            }}
                                            fullWidth
                                            sx={{
                                              "& .MuiInput-underline:before": {
                                                borderBottomColor: "#7635DD", // purple default
                                              },
                                              "& .MuiInput-underline:hover:before":
                                              {
                                                borderBottomColor: "#7635DD", // darker purple on hover
                                              },
                                              "& .MuiInput-underline:after": {
                                                borderBottomColor: "#7635DD", // purple when active/focused
                                              },
                                            }}
                                            InputProps={{
                                              disableUnderline: false,
                                              // endAdornment: (
                                              //   <span style={{ marginLeft: 8, color: "#666", fontSize: 14 }}>
                                              //     / {param?.originalWeightage}
                                              //   </span>
                                              // ),
                                              inputProps: {
                                                style: { MozAppearance: "textfield" },
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      )} */}
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    ))
                ) : (
                  <Typography>No Critical data available</Typography>
                )}
              </Grid>
            )}
          {/* nonCritical */}
          {data &&
            Object.values(data).some(
              (section) => section?.criticality === "NonCritical"
            ) && (
              <Grid
                item
                size={{
                  xs: 12,
                  md: 12,
                }}
                sx={{
                  borderRadius: 6,
                  border: "1px solid #EEEEEE",
                  p: 3,
                  mt: 3,
                }}
              >
                <Stack
                  direction="row"
                  gap={2}
                  mt={4}
                  mb={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignContent: "center",
                  }}
                >
                  <Typography
                    variant="body1"
                    fontWeight={600}
                    gutterBottom
                    color={positive}
                    sx={{
                      display: "inline-flex",
                      alignItems: "center",
                      gap: 0.5,
                    }}
                  >
                    Non Critical
                    <Tooltip title="Supporting parameters – Standards are important/encouraged to meet">
                      <InfoIcon
                        sx={{ fontSize: 18, color: "grey", cursor: "pointer" }}
                      />
                    </Tooltip>
                  </Typography>

                  {data && Object.keys(data).length > 0 && (
                    <Box
                      p={"5px 36px "}
                      sx={{
                        border: `1px solid ${
                          getSummaryStatus(statusSummary?.nonCritical).isPass === true
                            ? positive
                            : getSummaryStatus(statusSummary?.nonCritical).isPass === false
                              ? negative
                              : "#999"
                        }`,
                        borderRadius: 2,
                        color: getSummaryStatus(statusSummary?.nonCritical).isPass === true
                          ? positive
                          : getSummaryStatus(statusSummary?.nonCritical).isPass === false
                            ? negative
                            : "#777",
                        fontWeight: "bold",
                      }}
                    >
                      {getSummaryStatus(statusSummary?.nonCritical).label}
                    </Box>
                  )}
                </Stack>
                {/* <Divider sx={{ mb: 3, mt: 2 }} /> */}
                {data && Object.entries(data).length > 0 ? (
                  Object.entries(data)
                    .filter(
                      ([_, sectionData]) =>
                        sectionData?.criticality == "NonCritical"
                    )
                    .map(([sectionKey, sectionData], i) => (
                      <Accordion key={i}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography variant="body1" sx={{ flexGrow: 1 }}>
                            {sectionKey?.replace(/([a-z])([A-Z])/g, "$1 $2")}
                          </Typography>
                          {showScoringFeatures && (
                            <Typography sx={{ marginRight: 5 }}>
                              Overall Score:{" "}
                              <strong>
                                {sectionData?.parameterWeigthageCal}
                              </strong>
                            </Typography>
                          )}
                          <Chip
                            label={
                              getStatusInfo(
                                sectionData?.result ??
                                            sectionData?.overAllIssueFlagged ?? sectionData
                              ).label
                            }
                            size="small"
                            sx={{
                              mr: 3,
                              color:
                                getStatusInfo(
                                  sectionData?.result ??
                                    sectionData?.overAllIssueFlagged
                                ).isPass === true
                                  ? positive
                                  : getStatusInfo(
                                      sectionData?.result ??
                                        sectionData?.overAllIssueFlagged
                                    ).isPass === false
                                    ? negative
                                    : "grey",
                              border: "1px solid",
                              borderColor:
                                getStatusInfo(
                                  sectionData?.result ??
                                    sectionData?.overAllIssueFlagged
                                ).isPass === true
                                  ? positive
                                  : getStatusInfo(
                                      sectionData?.result ??
                                        sectionData?.overAllIssueFlagged
                                    ).isPass === false
                                    ? negative
                                    : "grey",
                              background: "transparent",
                            }}
                          />
                        </AccordionSummary>

                        <AccordionDetails>
                          <TableContainer>
                            <Table size="small">
                              <TableHead>
                                <TableRow>
                                  <TableCell>
                                    <strong>Sub Parameter</strong>
                                  </TableCell>
                                  <TableCell>
                                    <strong>Expectation</strong>
                                  </TableCell>

                                  <TableCell>
                                    <strong>Status</strong>
                                  </TableCell>
                                  {/* <TableCell>
                                    <strong>Timestamp</strong>
                                  </TableCell> */}
                                  <TableCell>
                                    <strong>Reason</strong>
                                  </TableCell>
                                  {showScoringFeatures && (
                                    <TableCell>
                                      <strong>AI Score</strong>
                                    </TableCell>)}
                                  {showScoringFeatures && (
                                    <TableCell>
                                      <strong>Rating</strong>
                                    </TableCell>)}
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {sectionData?.subParameters?.map(
                                  (param, idx) => (
                                    <TableRow key={idx}>
                                      <TableCell>
                                        {" "}
                                        <Tooltip title={param?.description}>
                                          <IconButton
                                            size="small"
                                            sx={{ color: primary }}
                                          >
                                            <InfoOutlined
                                              sx={{
                                                color: primary,
                                                fontSize: 20,
                                              }}
                                            />
                                          </IconButton>
                                        </Tooltip>
                                        {param?.parameter}
                                      </TableCell>
                                      <TableCell>
                                        {param?.expectation}
                                      </TableCell>
                                      <TableCell>
                                        <Chip
                                          label={
                                            getStatusInfo(
                                              param?.result ??
                                                param?.issueFlagged
                                            ).label
                                          }
                                          size="small"
                                          sx={{
                                            border: "1px solid",
                                            borderColor:
                                              getStatusInfo(
                                                param?.result ??
                                                  param?.issueFlagged
                                              ).isPass === true
                                                ? positive
                                                : getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === false
                                                  ? negative
                                                  : colorTheme(
                                                      "palette",
                                                      "secondary"
                                                    ).value,
                                            color:
                                              getStatusInfo(
                                                param?.result ??
                                                  param?.issueFlagged
                                              ).isPass === true
                                                ? positive
                                                : getStatusInfo(
                                                    param?.result ??
                                                      param?.issueFlagged
                                                  ).isPass === false
                                                  ? negative
                                                  : colorTheme(
                                                      "palette",
                                                      "secondary"
                                                    ).value,
                                            backgroundColor: "transparent",
                                            fontWeight: "medium",
                                          }}
                                        />
                                      </TableCell>
                                      {/* <TableCell>{param?.timeStamp}</TableCell> */}
                                      <TableCell>{param?.reason}</TableCell>
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <Typography sx={{ fontWeight: 600 }}>
                                            {param?.calculatedWeigthage}/
                                            {param?.originalWeightage}
                                          </Typography>
                                        </TableCell>
                                      )}
                                      {showScoringFeatures && (
                                        <TableCell>
                                          <Typography sx={{ fontWeight: 600 }}>
                                            {param?.rating}
                                          </Typography>
                                        </TableCell>
                                      )}
                                      {/* {showScoringFeatures && (
                                        <TableCell>
                                          <TextField
                                            type="tel"
                                            variant="standard"
                                            value={auditValues[idx] || ""}
                                            onChange={(e) => {
                                              const val = e.target.value;
                                              if (/^[0-9]*$/.test(val)) {
                                                setAuditValues((prev) => ({
                                                  ...prev,
                                                  [idx]: val,
                                                }));
                                              }
                                            }}
                                            fullWidth
                                            sx={{
                                              "& .MuiInput-underline:before": {
                                                borderBottomColor: "#7635DD", // purple default
                                              },
                                              "& .MuiInput-underline:hover:before":
                                              {
                                                borderBottomColor: "#7635DD", // darker purple on hover
                                              },
                                              "& .MuiInput-underline:after": {
                                                borderBottomColor: "#7635DD", // purple when active/focused
                                              },
                                            }}
                                            InputProps={{
                                              disableUnderline: false,
                                              endAdornment: (
                                                <span style={{}}>
                                                  / {param?.originalWeightage}
                                                </span>
                                              ),
                                              inputProps: {
                                                style: { MozAppearance: "textfield" },
                                              },
                                            }}
                                          />
                                        </TableCell>
                                      )} */}
                                    </TableRow>
                                  )
                                )}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </AccordionDetails>
                      </Accordion>
                    ))
                ) : (
                  <Typography>No data available</Typography>
                )}
              </Grid>
            )}
        </Grid>
      )}
    </Box>
  );
};

export default DrillDownAccordion;
